import ApiUrl from "../../../configTools/api";
// Guarantees the callback fires exactly once with an array, even on failure - the page
// clears its loading flag inside it, so a dropped request must not leave a shimmer spinning.
import { apiGetList } from "../../../configTools/apiGet";
const User = JSON.parse(localStorage.getItem("user-info"));

const GetCountry = (setValues) => {
    apiGetList(ApiUrl.Admin_Location_Country, (list, body)=>{
        setValues(list);
    });
}

const GetState = (selectedCountry,setValues) => {
    if(selectedCountry === 0){
        setValues([]);
        return;
    }
    apiGetList(ApiUrl.Admin_Location_State+"/"+selectedCountry, (list, body)=>{
        setValues(list);
    });
}

const GetCity = (setValues) => {
    apiGetList(ApiUrl.Admin_Location_City, (list, body)=>{
        setValues(list);
    });
}

const GetCitybyState = (selectedState,setValues) => {
    apiGetList(ApiUrl.Admin_Location_City+'/'+selectedState, (list, body)=>{
        setValues(list);
    });
}

const PostCountry = (body,setValues) => {
    fetch(ApiUrl.Admin_Location_Country,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            GetCountry(setValues);
        }
        else{
            alert(data.response);
        }
    });
}

const PostState = (body,selectedCountry,setValues) => {
    fetch(ApiUrl.Admin_Location_State,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            GetState(selectedCountry,setValues);
        }
        else{
            alert(data.response);
        }
    });
}

const PostCity = (body,setValues) => {
    fetch(ApiUrl.Admin_Location_City,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            GetCity(setValues);
        }
        else{
            alert(data.response);
        }
    });
}


const Functions = {GetCountry,GetState,GetCity,GetCitybyState,PostCountry,PostState,PostCity};
export default Functions;